/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2020
// All Rights Reserved
*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createFilterManagerFromReduxState } from '../../../BfFilterManager'
import { updateFilterListUrlAction } from '../../../../redux/BfFilterListUpdateURLAction'
import BfNumberInputWithFilter from './BfNumberInputWithFilter'
import { BfDataGridComponentWithContext } from '../../../../BfDataGridContext'

const BfNumberInputFilterWithReduxAction = (WrappedComponent) => {
  return class extends Component {
    _handleOnChange = (data) => {
      this.props.updateFilterListUrlAction(this.props.id, data)
    }

    render() {
      return <WrappedComponent filter={this.props.filter} onChange={this._handleOnChange} />
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const bfFilterManager = createFilterManagerFromReduxState(state, ownProps.id)

  return {
    filter: bfFilterManager.getFilterFromURLByName(ownProps.filterName)
  }
}
const BfNumberInputFilterWithRedux = connect(mapStateToProps, {
  updateFilterListUrlAction
})(BfNumberInputFilterWithReduxAction(BfNumberInputWithFilter))

export default BfDataGridComponentWithContext(BfNumberInputFilterWithRedux)
